import { useNavigate, useParams } from '@tanstack/react-router';

import { useClubProfileProgressQuery } from '@/shared/api/requests';

export const useClubTermsPage = () => {
  const { id: profileId } = useParams({ from: '/clubOwner/$id' });
  const navigate = useNavigate({ from: '/clubOwner/$id/profile/terms' });
  const progress = useClubProfileProgressQuery({ profileId });

  const progressItems = {
    schedule: {
      data: progress.data?.data.workScheduleCompletion,
      navigate: () =>
        navigate({
          to: '/clubOwner/$id/onboard/$step',
          params: {
            step: 'schedule'
          }
        })
    },
    contractTerms: {
      data: progress.data?.data.contractTermsCompletion,
      navigate: () =>
        navigate({
          to: '/clubOwner/$id/onboard/$step',
          params: {
            step: 'contract-terms'
          }
        })
    },
    payments: {
      data: progress.data?.data.paymentsCompletion,
      navigate: () =>
        navigate({
          to: '/clubOwner/$id/onboard/$step',
          params: {
            step: 'payments'
          }
        })
    },
    workConditions: {
      data: progress.data?.data.workingConditionsCompletion,
      navigate: () =>
        navigate({
          to: '/clubOwner/$id/onboard/$step',
          params: {
            step: 'work-conditions'
          }
        })
    },
    housing: {
      data: progress.data?.data.housingConditionsCompletion,
      navigate: () =>
        navigate({
          to: '/clubOwner/$id/onboard/$step',
          params: {
            step: 'housing'
          }
        })
    },
    penalties: {
      data: progress.data?.data.penaltiesCompletion,
      navigate: () =>
        navigate({
          to: '/clubOwner/$id/onboard/$step',
          params: {
            step: 'penalties'
          }
        })
    },
    photo: {
      data: progress.data?.data.photosCompletion,
      navigate: () =>
        navigate({
          to: '/clubOwner/$id/onboard/$step',
          params: {
            step: 'photo'
          }
        })
    },
    video: {
      data: progress.data?.data.videosCompletion,
      navigate: () =>
        navigate({
          to: '/clubOwner/$id/onboard/$step',
          params: {
            step: 'video'
          }
        })
    }
  };

  const queries = [progress];

  const isLoading = queries.some((q) => q.isLoading);

  return {
    state: { isLoading, progressItems, progress },
    fuunctions: {}
  };
};
